// Pre-fills the Globo contact form from URL params, e.g.
//   /pages/contact?inquiry=Purchase+Inquiry&message=...
// Used by the product page "still available for order" pre-order link.
//
// The Globo form renders (and often re-renders / hydrates) asynchronously,
// and contact-form-label-translator.js may rewrite labels/option values to
// Chinese. So we target fields by both English and Chinese labels and keep
// re-applying the values until the user starts editing the form.
(function () {
  const params = new URLSearchParams(window.location.search);
  const inquiry = params.get('inquiry');
  const message = params.get('message');

  if (!inquiry && !message) return;

  // Map English inquiry value -> all label spellings (English + translated),
  // so we match the <option> whether or not the translator has run yet.
  const inquiryAliases = {
    'Purchase Inquiry': ['Purchase Inquiry', '購買需求'],
  };
  const inquiryCandidates = inquiryAliases[inquiry] || [inquiry];

  const inquiryFieldLabels = ['Inquiry Type', '詢問類別'];
  const messageFieldLabels = ['Message', '內容'];

  let userTouched = false;

  function text(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function fieldGroup(el) {
    return (
      el.closest(
        '.globo-form-item, [class*="form-item"], [class*="field"], [class*="form-group"]'
      ) || el.parentElement
    );
  }

  function groupHasLabel(group, labels) {
    if (!group) return false;
    const label = group.querySelector('.label-content, label');
    return labels.includes(text(label));
  }

  function applySelect($form) {
    if (!inquiry) return;

    const selects = Array.from($form.querySelectorAll('select'));
    // Prefer the select inside the "Inquiry Type / 詢問類別" group.
    let select = selects.find((s) => groupHasLabel(fieldGroup(s), inquiryFieldLabels));
    // Fallback: any select that contains a Purchase Inquiry option.
    if (!select) {
      select = selects.find((s) =>
        Array.from(s.options).some((o) => inquiryCandidates.includes(text(o)))
      );
    }
    if (!select) return;

    const opt = Array.from(select.options).find((o) => inquiryCandidates.includes(text(o)));
    if (opt && select.value !== opt.value) {
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyMessage($form) {
    if (!message) return;

    const textareas = Array.from($form.querySelectorAll('textarea'));
    if (!textareas.length) return;

    // Prefer the textarea inside the "Message / 內容" group; fall back to the
    // first textarea in the form.
    const target =
      textareas.find((t) => groupHasLabel(fieldGroup(t), messageFieldLabels)) || textareas[0];

    if (target.value !== message) {
      target.value = message;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function apply() {
    const $form = document.querySelector('.globo-form-app');
    if (!$form) return;

    // Stop fighting the user once they start editing the form.
    if (!$form.dataset.prefillBound) {
      $form.dataset.prefillBound = 'true';
      $form.addEventListener('focusin', () => {
        userTouched = true;
      });
    }
    if (userTouched) return;

    try {
      applySelect($form);
      applyMessage($form);
    } catch (err) {
      console.error('[contact-form-prefill]', err);
    }
  }

  const observer = new MutationObserver(apply);
  observer.observe(document.body, { childList: true, subtree: true });
  apply();

  // Keep re-applying for a short window to survive Globo's async re-renders,
  // then give up so we never permanently override the user.
  let ticks = 0;
  const timer = setInterval(() => {
    apply();
    if (userTouched || ++ticks > 40) {
      clearInterval(timer);
      observer.disconnect();
    }
  }, 250);
})();
